import { render } from "./InjuryDrillDownModal.vue?vue&type=template&id=490d070a&scoped=true"
import script from "./InjuryDrillDownModal.vue?vue&type=script&lang=js"
export * from "./InjuryDrillDownModal.vue?vue&type=script&lang=js"

import "./InjuryDrillDownModal.vue?vue&type=style&index=0&id=490d070a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490d070a"]])

export default __exports__